import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IReturnDecision } from '../../interfaces/return-list/return-decision.interface';
import { ITableServerFilter } from 'src/app/common/interfaces/table/table-server-filter.inteface';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { IReturnList } from '../../interfaces/return-list/return-list.interface';
import { AbstractRtpReturnListService } from '../abstraction/abstract.return-request-list.service';

@Injectable({
  providedIn: 'root',
})
export class ReturnRequestListService extends AbstractRtpReturnListService {
  controllerUrl = `/manager/rtp/returnlist`;
  urlGetRtpReturnRequestList = `${environment.apiUrl}${this.controllerUrl}/grid`;
  urlGetRtpReturnRequestListExportCSV = `${environment.apiUrl}${this.controllerUrl}/gridExportCSV`;
  urlGetRtpReturnRequestListExportExcel = `${environment.apiUrl}${this.controllerUrl}/gridExportExcel`;
  urlGetRtpReturnRequestDetailGrid = `${environment.apiUrl}${this.controllerUrl}/returnListDetail`;
  urlGetRtpSingleRecordReturnList = `${environment.apiUrl}${this.controllerUrl}/gridSingleRecord`;
  urlPostDecisionSubmit = `${environment.apiUrl}${this.controllerUrl}/returnDecision`;
  urlGetReasonDenyList = `${environment.apiUrl}${this.controllerUrl}/returnDenyReasonList`;
  urlGetReturnStatusList = `${environment.apiUrl}${this.controllerUrl}/returnStatusList`;
  urlGetAlternativePaymentChannelList = `${environment.apiUrl}${this.controllerUrl}/returnAlternativePaymentChannelList`;

  constructor(private http: HttpClient) {
    super();
  }

  paymentChannelList(): Promise<any> {
    return this.http
      .get<any>(`${this.urlGetAlternativePaymentChannelList}`)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }
  returnStatusList(): Promise<any> {
    return this.http
      .get<any>(`${this.urlGetReturnStatusList}`)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }
  reasonDenyList(): Promise<any> {
    return this.http
      .get<any>(`${this.urlGetReasonDenyList}`)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }
  getById(rtpUniqueMessageId: string): Promise<any> {
    return this.http
      .get<any>(`${this.urlGetRtpReturnRequestDetailGrid}/${rtpUniqueMessageId}`)
      .toPromise();
  }

  tableFilter(filter: ITableServerFilter): Promise<ITableServerResponseFilter | undefined> {
    return this.http
      .post<ITableServerResponseFilter>(`${this.urlGetRtpReturnRequestList}`, filter)
      .toPromise();
  }
  tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    return this.http
      .post(`${this.urlGetRtpReturnRequestListExportCSV}`, filter, {
        responseType: 'blob',
      })
      .toPromise();
  }
  tableExportExcel(filter: ITableServerFilter): Promise<any> {
    return this.http.post(`${this.urlGetRtpReturnRequestListExportExcel}`, filter).toPromise();
  }

  tableFilterSingleRecordById(messageId: string): Promise<IReturnList | undefined> {
    return this.http
      .get<IReturnList>(`${this.urlGetRtpSingleRecordReturnList}/${messageId}`)
      .toPromise();
  }

  override decisionSubmit(decision: IReturnDecision): Promise<IWebMessage | undefined> {
    return this.http.post<IWebMessage>(`${this.urlPostDecisionSubmit}`, decision).toPromise();
  }
  override returnRequestList(): Promise<any> {
    throw new Error('Method not implemented.');
  }
}
